"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var InfoCircleOutline_1 = __importDefault(require("../icons/generated/InfoCircleOutline"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  cursor: pointer;\n"], ["\n  position: relative;\n  cursor: pointer;\n"])));
var ContentWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 100;\n  background-color: ", ";\n  color: ", ";\n  margin-top: 10px;\n  max-width: 250px;\n  right: 100%;\n  top: -15px;\n  margin-right: 15px;\n  font-size: 14px;\n  padding: 17px;\n  min-width: 200px;\n"], ["\n  position: absolute;\n  z-index: 100;\n  background-color: ",
    ";\n  color: ",
    ";\n  margin-top: 10px;\n  max-width: 250px;\n  right: 100%;\n  top: -15px;\n  margin-right: 15px;\n  font-size: 14px;\n  padding: 17px;\n  min-width: 200px;\n"])), function (_a) {
    var tooltip = _a.theme.colours.tooltip;
    return tooltip.backgroundColor;
}, function (_a) {
    var tooltip = _a.theme.colours.tooltip;
    return tooltip.textColor;
});
var Arrow = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 10px solid\n    ", ";\n  position: absolute;\n  top: 10px;\n  margin-left: -5px;\n  right: -10px;\n"], ["\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 10px solid\n    ",
    ";\n  position: absolute;\n  top: 10px;\n  margin-left: -5px;\n  right: -10px;\n"])), function (_a) {
    var tooltip = _a.theme.colours.tooltip;
    return tooltip.backgroundColor;
});
exports.Icon = styled_components_1.default(InfoCircleOutline_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  fill: ", ";\n"], ["\n  width: 20px;\n  height: 20px;\n  fill: ",
    ";\n"])), function (_a) {
    var tooltip = _a.theme.colours.tooltip;
    return tooltip.iconColor;
});
// Note that if you pass content as react elements each React Element in the array has to have its unique key prop.
var Tooltip = function (_a) {
    var children = _a.children, content = _a.content;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    return (react_1.default.createElement(Wrapper, { "data-test-id": 'tool-tip', onMouseEnter: function () { return setOpen(true); }, onMouseLeave: function () { return setOpen(false); } },
        children,
        open && (react_1.default.createElement(ContentWrapper, { "data-test-id": 'tool-tip-content' },
            react_1.default.createElement(Arrow, null),
            content))));
};
exports.default = Tooltip;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
